<template>
  <div id="scoreSet" class="page-content">
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/systemSetupList/systemSetup'}">积分设置</el-breadcrumb-item>
      <el-breadcrumb-item>信用积分设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="drawer-subtitle_common">
      <span>信用积分周期设置</span>
    </div>
    <section class="seaerch-wrapper">
      <div class="setExplain margin_bottom20">
        <div class="title">
          <i class="el-icon-warning-outline" style="color: #FAAD14;font-size: 24px;"></i>
          信用积分周期设置说明
        </div>
        <div style="padding-left: 27px;text-align: left;color: #999999;margin: 6px 0;">
          1、积分周期默认按自然整年为周期。积分周期支持按照自然整年、半年、季度、月，自定义半年、半年、季度设置。
        </div>
        <div style="padding-left: 27px;text-align: left;color: #999999;margin: 6px 0;">
          2、积分周期调整后，当前积分周期从调整日开始起，至本周期积分结束，为一个积分周期。
        </div>
        <div style="padding-left: 27px;text-align: left;color: #999999;margin: 6px 0;">
          3、积分周期调整后，调整日之前历史积分周期内的店铺剩余积分将被归零，仅保留店铺的积分扣分记录。
        </div>
      </div>
      <div class="flex_between socre_period">
        <div
          class="setExplain2"
          @click="changeCycle(index)"
          :class="activeIdex===index?'active':''"
          v-for="(item,index) in typeList"
          :key="item.title"
          style="cursor:pointer;"
        >
          <div :class="activeIdex===index?'active_title':''" class="title2">
            {{item.title}}
            <i class="el-icon-edit-outline" v-if="item.custom===1" @click="editScore"></i>
          </div>
          <p>{{item.info}}</p>
        </div>
      </div>

      <div class="margin_top20">
        <el-button
          type="primary"
          size="small"
          v-show="cycleifEdit"
          @click="cycleifEdit=!cycleifEdit"
        >编辑</el-button>
        <el-button type="confire_btn" size="small" v-show="!cycleifEdit" @click="cancelScore(1)">确认</el-button>
        <el-button type size="small" v-show="!cycleifEdit" @click="cycleifEdit=!cycleifEdit">取消</el-button>
      </div>
    </section>
    <div class="drawer-subtitle_common">
      <span>信用积分总分值设置</span>
    </div>
    <section class="seaerch-wrapper">
      <div class="setExplain margin_bottom20">
        <div class="title">
          <i class="el-icon-warning-outline" style="color: #FAAD14;font-size: 24px;"></i>
          信用积分周期设置说明
        </div>
        <div style="padding-left: 27px;text-align: left;color: #999999;margin: 6px 0;">
          1、信用积分总分值在每个积分周期内有效，下一个积分周期自动回归到设置的总分值。
        </div>
        <div style="padding-left: 27px;text-align: left;color: #999999;margin: 6px 0;">
          2、信用积分总分值设置时请根据积分周期长度范围，积分周期长的总分值可以设置大一些。常见的总分值有12分制、100分制等等。
        </div>
        <div style="padding-left: 27px;text-align: left;color: #999999;margin: 6px 0;">
          3、信用积分总分值设置后可以调整，调整后本周期内的积分按照调整后的总分值计算。
        </div>
      </div>
      <el-form>
        <el-form-item label="总分值：" :required="true" label-width="100px">
          <el-input
            placeholder="请输入大于0的整数"
            size="small"
            class="score_input"
            v-model="credit.score"
            :disabled="ifEdit"
          ></el-input>
          <div style="float:right">
            <el-button type="primary" size="small" v-show="ifEdit" @click="ifEdit=!ifEdit">编辑</el-button>
            <el-button type="confire_btn" size="small" v-show="!ifEdit" @click="cancelScore(2)">确认</el-button>
            <el-button type size="small" v-show="!ifEdit" @click="ifEdit=!ifEdit">取消</el-button>
          </div>
        </el-form-item>
      </el-form>
    </section>
    <div class="drawer-subtitle_common">
      <span>信用积分规则设置</span>
    </div>
    <section class="seaerch-wrapper">
      <el-form>
        <el-form-item label="信用积分规则" label-width="100px">
          <el-input
            type="textarea"
            class="area_text"
            :disabled="ruleifEdit"
            v-model="credit.describe"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="margin_top20">
        <el-button
          type="primary"
          size="small"
          v-show="ruleifEdit"
          @click="ruleifEdit=!ruleifEdit"
        >编辑</el-button>
        <el-button type="confire_btn" size="small" v-show="!ruleifEdit" @click="cancelScore(3)">确认</el-button>
        <el-button type size="small" v-show="!ruleifEdit" @click="ruleifEdit=!ruleifEdit">取消</el-button>
      </div>
    </section>
    <!-- 自定义时间 -->
    <Comfirm
      :visible="visible"
      title="自定义季度积分周期"
      @on-close="visible = false"
      @on-comfirm="onPassData"
    >
      <template v-slot:content>
        <el-form>
          <el-form-item label="初始月份：" :required="true" label-width="100px">
            <el-select v-model="checkMonth" size="small">
              <el-option v-for="item in mounthData" :key="item.id" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </Comfirm>
  </div>
</template>
<script>
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { mapState, mapActions } from "vuex";
import Comfirm from "components/comfirmDialog/comfirmDialog.vue";
import { getMonthBetween } from "@/libs/date";

export default {
  data() {
    return {
      ifEdit: true,
      ruleifEdit: true,
      cycleifEdit: true,
      credit: { score: 0, describe: "" },
      activeIdex: null,
      checkMonth: "",
      visible: false,
      mounthData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    };
  },
  components: { Comfirm },
  mounted() {
    this.getInstallList(); //信用总积分初始化
  },
  computed: {
    ...mapState({
      typeList: (state) => state.creditScore.typeList,
      dateCycle: (state) => state.creditScore.dateCycle,
    }),
  },
  methods: {
    editScore() {
      if (!this.cycleifEdit) {
        this.visible = true;
      }
    },
    onPassData() {
      this.startmonth = this.checkMonth;
      this.credit.type=this.typeList[this.activeIdex].type
      this.credit.startmonth=this.startmonth
      this.getMonthName()
      this.visible = false;
    },
    async getInstallList() {
      fetchGet("hcm/hcmReport/getInstallListByReportId").then((res) => {
        if (res.status == "10000") {
          let result = res.data;
          let { startmonth, type } = result;
          this.credit = result;
          this.typeList.map((item, index) => {
            if (type == item.type && !startmonth) {
              this.activeIdex = Number(type) - 1;
            } else if (type == item.type && startmonth) {
              this.activeIdex = type == 4 ? 4 : type == 3 ? 5 : 6;
            }
          });
          if (startmonth) {
            this.getMonthName();
          } else {
            this.typeList[4].info = "";
            this.typeList[5].info = "";
            this.typeList[6].info = "";
          }
        }
      });
    },
    async getMonthName() {
      let { type, createtime, startmonth } = this.credit;
      type = Number(type);
      let timestamp = new Date().getTime();
      let dateAfter = new Date(timestamp);
      let year = dateAfter.getFullYear();
      let startTime = `${year}-${startmonth}`;
      let endTime = `${year + 1}-${startmonth - 1}`;
      let fullMonth = getMonthBetween(startTime, endTime);//时间范围内的各个月份
      let resultMonth = []; //一年范围内所有的月份
      let resultName = [];
      let result = [];
      Object.keys(fullMonth).forEach((key) => {
        resultMonth.push(...fullMonth[key]);
      });
      let silceIndex = type === 4 ? 12 : type === 3 ? 6 : type === 2 ? 3 : 0;
      for (var i = 0; i < resultMonth.length; i += silceIndex) {
        //根据type类型 进行分组
        result.push(resultMonth.slice(i, i + silceIndex));
      }
      result.forEach((item, index) => {
        //获取最后的时间文案 根据类型判断
        if (type === 2) {
          //季度
          resultName.push(
            `${item[0].slice(5, 7)}/${item[1].slice(5, 7)}/${item[2].slice(
              5,
              7
            )}`
          );
        } else if (type === 3) {
          //半年
          resultName.push(`${item[0].slice(5, 7)}月至${item[5].slice(5, 7)}月`);
        }
      });
      if (type == 4) {
        //整年
        this.typeList[4].info = `每年的${startTime.slice(
          5,
          7
        )}月至次年的${endTime.slice(5, 7)}月为一个积分周期`;
        this.typeList[5].info = "";
        this.typeList[6].info = "";
      } else if (type == 3) {
        //半年
        this.typeList[5].info = `每年的${resultName[0]}为一个积分周期，${resultName[1]}为下一个积分周期`;
        this.typeList[4].info = "";
        this.typeList[6].info = "";
      } else if (type == 2) {
        //季度
        this.typeList[6].info = `自然月${String(resultName)}分别为一个积分周期`;
        this.typeList[5].info = "";
        this.typeList[4].info = "";
      }
    },
    cancelScore() {
      let data = {
        score: this.credit.score,
        describe: this.credit.describe,
        id: this.credit.id,
        type: Number(this.typeList[this.activeIdex].type), //积分周期1自然月2自然季度3自然半年4自然年
      };
      let activeIdex = this.activeIdex;
      if (activeIdex === 4 || activeIdex === 5 || activeIdex === 6) {
        data.startmonth = this.startmonth
          ? this.startmonth
          : this.credit.startmonth;
        data.message = this.typeList[this.activeIdex].info;
      } else {
        data.message = '';
      }
      fetchPost("hcm/hcmReport/saveInstall", data).then((res) => {
        if (res.status === "10000") {
          this.$message.success("成功");
          this.ifEdit = true;
          this.ruleifEdit = true;
          this.cycleifEdit = true;
          this.getInstallList(); //信用总积分初始化
          this.startmonth = "";
          this.checkMonth = "";
        } else {
          this.$message.error(res.message);
        }
      });
    },
    changeCycle(index) {
      if (!this.cycleifEdit) this.activeIdex = index;
    },
  },
};
</script>
<style lang="scss">
@import "style/fontSize.scss";

#scoreSet {
  .el-dialog {
    width: 20% !important;
  }
  .el-icon-edit-outline {
    color: #1890ff;
  }
  .area_text .el-textarea__inner {
    height: 300px;
  }
  .f16 {
    margin-bottom: 20px;
  }
  .seaerch-wrapper {
    padding: 20px;
  }
  .score_input {
    width: 85%;
    margin-right: 5%;
  }
  .setExplain {
    border: 1px solid #f9d55c;
    border-radius: 8px;
    background: #fffcf3;
    font-size: 14px;
    padding: 24px 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
    min-height: 150px;
    div {
      text-align: center;
    }
    .title {
      text-align: left;
    }
    p {
      text-align: left;
      color: #999;
    }
  }
  .socre_period {
    flex-wrap: wrap;
    & > div:nth-child(8) {
      opacity: 0;
      cursor: default !important;
    }
    .active_title {
      color: #bda571;
    }
    .title2 {
      text-align: left;
      font-size: 18px;
    }
    .setExplain {
      width: 22%;
      box-shadow: 0 0 11px #dfdfdf;
      border: 1px solid #dfdfdf;
      background: #fff;
      margin-bottom: 38px;
    }
    .setExplain2 {
      border: 1px solid #f9d55c;
      border-radius: 8px;
      background: #fffcf3;
      font-size: 14px;
      padding: 24px 20px;
      box-sizing: border-box;
      margin-bottom: 8px;
      min-height: 150px;
      width: calc(25% - 8px);
      border: 1px solid #dfdfdf;
      background: #fff;
    }

    .active {
      border: 1px solid #bda571;
    }
  }
}
</style>
